import { render, staticRenderFns } from "./WorldCLassRequestDetails.vue?vue&type=template&id=71ee2fda&"
import script from "./WorldCLassRequestDetails.vue?vue&type=script&lang=js&"
export * from "./WorldCLassRequestDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports